import { useKeycloak } from '@react-keycloak/web';
import { FC, useEffect } from 'react';

import AccessDenied from '@/app/ui/AccessDenied/AccessDenied';
import { FullPageLoader } from '@/shared/ui/Loading';

const AuthorizedDeniedRoutes: FC = () => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (initialized && !keycloak?.authenticated) {
      keycloak.createLoginUrl({ redirectUri: window.location.href }).then((url: string) => {
        window.location.replace(url);
      });
    }
  }, [keycloak, initialized]);

  if (!initialized || !keycloak?.authenticated) return <FullPageLoader />;

  return <AccessDenied />;
};

export default AuthorizedDeniedRoutes;
